const root = "/supervision";

export const supervisionRoutes = {
  root,
  dashboard: `${root}/dashboard`,
} as const;
